import { Accordion, AccordionBody, AccordionHeader, Button, Card, Input } from '@material-tailwind/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GetAllOrderProductsByOrderId, GetOrder } from '../../services/ApiServices/OrderService';
import { formatPrice } from '../../services/formatPrice';
import { PaymentProductRow } from '../PaymentProductRow';
import NotFound from './NotFound';

function OrderDetail({ uid, setLoading }: any) {
    const { id } = useParams();
    const navigate = useNavigate();

    const [order, setOrder] = useState({} as any);
    const [orderProducts, setOrderProducts] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const [openPayment, setOpenPayment] = useState(1);
    const [openShipping, setOpenShipping] = useState(1);
    const [openUserInfo, setOpenUserInfo] = useState(1);

    const fetchOrderProducts = async () => {
        let userInfos = null;
        setLoading(true);
        try {
            userInfos = await GetAllOrderProductsByOrderId(id);
            setLoading(false);
            setOrderProducts(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                // If the error response contains a message, set it as the error message
                setErrorMessage(error.response.data.message);
            } else {
                // If the error is something else, set a generic error message
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
            return;
        }
    }

    const fetchOrder = async () => {
        let userInfos = null;
        try {
            userInfos = await GetOrder(id);
            setOrder(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                // If the error response contains a message, set it as the error message
                setErrorMessage(error.response.data.message);
            } else {
                // If the error is something else, set a generic error message
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    useEffect(() => {
        fetchOrderProducts();
        fetchOrder();
    }, []);

    if (!uid) {
        navigate('/login');
    }
    if (!id) {
        return <NotFound />
    }

    return (
        <div className="about-container w-full my-5">
            <div className="about-header">
                <h2 className="text-3xl text-center font-semibold">Đơn hàng của bạn</h2>
                <div className="underline"></div>
                <div className="order-info w-full mb-3 px-12">
                    <div className="">
                        {orderProducts.length > 0 && orderProducts.map((product: any) => (
                            <PaymentProductRow product={product} key={product.id} />
                        ))}
                    </div>
                    <div className="order-info flex">
                        <p className="text-2xl grow"><strong>#ID:</strong></p>
                        <p className="font-medium text-black">{order.id}</p>
                    </div>
                    <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
                    <h2 className="text-2xl font-medium mb-3">Tổng hóa đơn</h2>
                    <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
                    <div className="order-info flex">
                        <p className="font-medium grow">Tổng tiền</p>
                        <p className="font-medium text-red-500">{formatPrice(order.totalPrice)}</p>
                    </div>
                    <div className="flex">
                        <p className="font-medium grow">Phí vận chuyển</p>
                        <p className="text-red-500 font-medium">{formatPrice(0)}</p>
                    </div>
                    <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
                    <div className="flex text-xl">
                        <p className="font-medium grow">Tổng cộng: </p>
                        <p className="text-red-500 font-medium">{formatPrice(order.totalPrice)}</p>
                    </div>
                    <div className="flex text-xl">
                        <p className="font-medium grow">Trạng thái: </p>
                        <p className="text-black font-medium">{order.status}</p>
                    </div>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    <Accordion open={openShipping === 1} placeholder={""} >
                        <AccordionHeader placeholder={""} onClick={() => setOpenShipping(openShipping === 1 ? 0 : 1)}>
                            <h2 className="text-2xl font-medium mb-3">Vận chuyển</h2>
                        </AccordionHeader>
                        <AccordionBody placeholder={""}>
                            {order.shipments && order.shipments.sort((a: any, b: any) =>
                                new Date(a.shippingDate).getTime() - new Date(b.shippingDate).getTime())
                                .map((shipment: any) => (
                                    <Card className="p-5" placeholder={""}>
                                        <div className="flex mb-2" key={shipment.id}>
                                            <p className="font-medium grow">Ngày</p>
                                            <p className="text-black font-medium">{moment(shipment.shippingDate).format("DD/MM/YYYY")}</p>
                                        </div>
                                        <div className="flex mb-2" key={shipment.id}>
                                            <p className="font-medium grow">Ngày dự kiến</p>
                                            <p className="text-black font-medium">{moment(shipment.expectedDeliveryDate).format("DD/MM/YYYY")}</p>
                                        </div>
                                        <div className="flex" key={shipment.id}>
                                            <p className="font-medium grow">Trạng thái</p>
                                            <p className="text-green-500 font-medium">{shipment.status}</p>
                                        </div>
                                    </Card>
                                ))}
                        </AccordionBody>
                    </Accordion>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    <Accordion open={openUserInfo === 1} placeholder={""} >
                        <AccordionHeader placeholder={""} onClick={() => setOpenUserInfo(openUserInfo === 1 ? 0 : 1)}>
                            <h2 className="text-2xl font-medium mb-3">Thông tin người nhận</h2>
                        </AccordionHeader>
                        <AccordionBody placeholder={""}>
                            {order.userInfo &&
                                <Card className="p-5" placeholder={""}>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Tên</p>
                                        <p className="text-black font-medium">{order.userInfo.receiverName}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.userInfo.receiverName}>
                                        <p className="font-medium grow">Email</p>
                                        <p className="text-black font-medium">{order.userInfo.email}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Địa chỉ</p>
                                        <p className="text-black font-medium">{order.userInfo.address + ", " + order.userInfo.addressInfo}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Số điện thoại</p>
                                        <p className="text-black font-medium">{order.userInfo.phoneNumber}</p>
                                    </div>
                                    <div className="flex" key={order.id}>
                                        <p className="font-medium grow">Thông tin thêm</p>
                                        <p className="text-black font-medium">{order.userInfo.additionalInfo}</p>
                                    </div>
                                </Card>
                            }
                        </AccordionBody>
                    </Accordion>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    {/*JSON.stringify(order)*/}
                    <Accordion open={openPayment === 1} placeholder={""} >
                        <AccordionHeader placeholder={""} onClick={() => setOpenPayment(openPayment === 1 ? 0 : 1)}>
                            <h2 className="text-2xl font-medium mb-3">Thanh toán</h2>
                        </AccordionHeader>
                        <AccordionBody placeholder={""}>
                            {order.payments && order.payments.map((payment: any) => (
                                <Card className="p-5" placeholder={""}>
                                    <div className="flex mb-2" key={payment.id}>
                                        <p className="font-medium grow">Tổng tiền</p>
                                        <p className="text-red-500 font-medium">{formatPrice(payment.amount)}</p>
                                    </div>
                                    <div className="flex mb-2" key={payment.id}>
                                        <p className="font-medium grow">Trạng thái</p>
                                        <p className="text-black font-medium">{payment.status}</p>
                                    </div>
                                    <div className="flex mb-2" key={payment.id}>
                                        <p className="font-medium grow">Mô tả</p>
                                        <p className="text-black font-medium">{payment.description}</p>
                                    </div>
                                    <div className="flex" key={payment.id}>
                                        <p className="font-medium grow">Ngày thanh toán</p>
                                        <p className="text-black font-medium">{moment(payment.paymentDate).format("DD/MM/YYYY")}</p>
                                    </div>
                                    <div className="flex mt-2">
                                        <p className="font-medium grow">Ngày giao dự kiến: </p>
                                        <p className="text-black font-medium">{moment(order.expectedOrderDate).format("DD/MM/YYYY")}</p>
                                    </div>
                                </Card>
                            ))}
                        </AccordionBody>
                    </Accordion>
                </div>

            </div>
        </div>
    );
}

export default OrderDetail;
